import { PromotionalMessagesUI } from "./PromotionalMessagesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { getPromotionalMessagesToShow } from "@/utils/product/getPromotionalMessagesToShow";
import { hasAnyStock } from "@/utils/product/hasAnyStock";
import { getColourGroupForVariant } from "@/utils/product/getColourGroupForVariant";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";

export function PromotionalMessages({
  flags,
  product,
  configProps,
}: Pick<StandardProps, "flags" | "product" | "configProps">) {
  const { variant, isSelected } = useVariant(product);
  const { brand } = product;
  const isBlackOverride = isDiorBrand(brand?.name);
  const variantGroupsDefault = Boolean(configProps?.useVariantGroups ?? true);
  const isPricePromise = !!flags?.showPricePromiseInPromoMessage.value;
  const isNewTypographyEnabled = flags?.useNewTypography.value === true;

  const messages = getPromotionalMessagesToShow(
    product,
    variant,
    isSelected,
    variantGroupsDefault && product.variantGroups
      ? getColourGroupForVariant(product.variantGroups, variant.id)
      : undefined,
  );

  let countdownTimerAvailabileToOrder = false;

  const isFullyOutOfStock =
    !hasAnyStock(product) &&
    product.__typename === "SimpleProduct" &&
    product.variants?.length === 1;

  if (!isSelected) {
    countdownTimerAvailabileToOrder = !isFullyOutOfStock;
  } else {
    countdownTimerAvailabileToOrder =
      variant.availability?.availableToOrder || false;
  }

  return (
    <PromotionalMessagesUI
      promotionalMessages={messages}
      countdownTimerAvailabileToOrder={countdownTimerAvailabileToOrder}
      isBlackOverride={isBlackOverride}
      isPricePromise={isPricePromise}
      isNewTypographyEnabled={isNewTypographyEnabled}
    />
  );
}
